import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RevealCard from "./components/RevealCard";
import DailyCard from "./components/DailyCard";
import CommentCard from "./components/CommentCard";
import { reveals, dailyContests, comments } from "@/mocks/home";

export default function Home() {
  const { t } = useTranslation();
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -320, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 320, behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "51暗网吃瓜",
            url: "http://hnwmjg.cn/",
            description: "51暗网吃瓜app下载与入口导航页，同步51暗网吃瓜网站最新地址，汇聚每日大赛、网红塌房现场及匿名黑料爆料，热门大瓜不停更。",
            potentialAction: {
              "@type": "SearchAction",
              target: "http://hnwmjg.cn/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "51暗网吃瓜",
            url: "http://hnwmjg.cn/",
            description: "国内领先的娱乐八卦资讯聚合平台",
            sameAs: ['http://hnwmjg.cn/'],
          }),
        }}
      />

      <section className="relative h-[85vh] md:h-screen w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20urban%20night%20cityscape%20with%20warm%20amber%20and%20crimson%20neon%20light%20reflections%2C%20soft%20bokeh%20background%2C%20mysterious%20dramatic%20atmosphere%2C%20cinematic%20composition%2C%20no%20people%2C%20dark%20vignette%20edges%2C%20elegant%20minimal%20night%20scene%2C%20rich%20warm%20tones%20against%20deep%20shadows%2C%20editorial%20photography%20style%20with%20blurred%20city%20lights&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="51暗网吃瓜 - 全网吃瓜第一站"
          title="51暗网吃瓜 - 每日大赛实时追踪"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

        <div className="absolute inset-0 flex items-end md:items-center px-4 md:px-6 pb-24 md:pb-0">
          <div className="max-w-7xl mx-auto w-full">
            <div className="max-w-2xl">
              <span className="inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-medium text-white border border-white/30 bg-white/10 backdrop-blur-sm mb-4 md:mb-6 whitespace-nowrap">
                {t("hero.tag")}
              </span>
              <h1 className="text-3xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight md:leading-tight mb-3 md:mb-4">
                51暗网吃瓜
              </h1>
              <p className="text-base md:text-xl text-white/80 leading-relaxed mb-6 md:mb-8 max-w-lg">
                {t("hero.subtitle")}
              </p>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <a
                  href="#cta-download"
                  className="inline-flex items-center gap-2 px-6 py-3 md:px-8 md:py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t("hero.cta")}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </a>
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-6 py-3 md:px-8 md:py-3.5 rounded-full text-white font-medium text-sm md:text-base border border-white/40 hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t("hero.secondary")}
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-arrow-down-line text-white/60 text-xl"></i>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-end justify-between mb-8 md:mb-10">
            <div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
                {t("section.reveal")}
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                {t("section.reveal.desc")}
              </p>
            </div>
            <Link
              to="/"
              className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("section.reveal.viewAll")}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            {reveals.map((item) => (
              <RevealCard
                key={item.id}
                title={item.title}
                category={item.category}
                imageUrl={item.imageUrl}
                time={item.time}
                hot={item.hot}
                articleSlug={"articleSlug" in item ? (item as { articleSlug?: string }).articleSlug : undefined}
                categorySlug={"categorySlug" in item ? (item as { categorySlug?: string }).categorySlug : undefined}
              />
            ))}
          </div>

          <div className="mt-6 text-center sm:hidden">
            <Link
              to="/"
              className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 cursor-pointer whitespace-nowrap"
            >
              {t("section.reveal.viewAll")}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-end justify-between mb-8 md:mb-10">
            <div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
                {t("section.daily")}
                <span className="text-primary-500 ml-2">{t("section.daily.hot")}</span>
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                {t("section.daily.desc")}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={scrollLeft}
                className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-background-300 hover:bg-background-100 transition-colors cursor-pointer"
                aria-label="向左滚动"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-left-s-line text-foreground-600 text-base"></i>
                </div>
              </button>
              <button
                onClick={scrollRight}
                className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-background-300 hover:bg-background-100 transition-colors cursor-pointer"
                aria-label="向右滚动"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-foreground-600 text-base"></i>
                </div>
              </button>
            </div>
          </div>

          <div
            ref={scrollRef}
            className="flex gap-4 md:gap-6 overflow-x-auto scrollbar-none pb-2"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {dailyContests.map((item) => (
              <DailyCard
                key={item.id}
                rank={item.rank}
                title={item.title}
                desc={item.desc}
                hot={item.hot}
                imageUrl={item.imageUrl}
                categorySlug={item.categorySlug}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-800 mb-4">
            {t("section.comments.tag")}
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-1">
            {t("section.comments")}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 md:mb-10">
            {t("section.comments.desc")}
          </p>

          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
            {comments.map((item) => (
              <div key={item.id} className="break-inside-avoid mb-4 md:mb-5">
                <CommentCard
                  nickname={item.nickname}
                  username={item.username}
                  avatar={item.avatar}
                  content={item.content}
                  likes={item.likes}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <p className="text-xs md:text-sm text-foreground-400 font-medium mb-6 md:mb-8 tracking-wider uppercase">
            —— About ——
          </p>
          <h2 className="text-xl md:text-3xl font-heading font-semibold text-foreground-900 mb-6 md:mb-8">
            {t("section.about")}
          </h2>
          <p className="text-sm md:text-lg text-foreground-600 leading-relaxed md:leading-loose max-w-2xl mx-auto">
            {t("section.about.content")}
          </p>
        </div>
      </section>

      <section id="cta-download" className="relative h-[80vh] md:h-screen w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20neon%20bokeh%20city%20lights%20at%20night%2C%20soft%20amber%20and%20coral%20glow%2C%20cinematic%20atmosphere%2C%20elegant%20blurred%20background%2C%20luxurious%20modern%20aesthetic%2C%20no%20people%2C%20rich%20warm%20color%20palette%2C%20soft%20focus%20urban%20lights%2C%20dreamy%20night%20scene%2C%20high%20end%20editorial%20style&width=1920&height=1080&seq=cta-bg-01&orientation=landscape"
          alt="下载51暗网吃瓜APP"
          title="51暗网吃瓜APP下载"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

        <div className="absolute inset-0 flex items-center justify-center px-4 md:px-6">
          <div className="text-center max-w-lg">
            <h2 className="text-2xl md:text-5xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
              {t("cta.title")}
            </h2>
            <p className="text-sm md:text-lg text-white/70 mb-8 md:mb-10 leading-relaxed">
              {t("cta.subtitle")}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="#"
                className="inline-flex items-center gap-2.5 px-7 py-3.5 md:px-10 md:py-4 rounded-full bg-white text-foreground-900 font-semibold text-sm md:text-base hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                  <i className="ri-apple-fill text-base md:text-lg"></i>
                </div>
                {t("cta.ios")}
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2.5 px-7 py-3.5 md:px-10 md:py-4 rounded-full bg-accent-500 text-white font-semibold text-sm md:text-base hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                  <i className="ri-android-fill text-base md:text-lg"></i>
                </div>
                {t("cta.android")}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}